import styled from 'styled-components';

import StyledPillVariant from './StyledPillVariant';

export default styled(StyledPillVariant)`
	b {
		background-color: transparent;
		border: 0.1rem solid var(--cd-color);
		color: var(--dark-text);
	}
`;
